<div class="flex justify-center w-full">
  <p-datepicker
    id="simple-calendar"
    class="w-[322px]"
    inputId="calendar"
    dateFormat="dd/mm/yy"
    [placeholder]="placeholder()"
    [disabled]="disabled"
    [(ngModel)]="date"
    [maxDate]="maxDate"
    [minDate]="minDate"
    (ngModelChange)="onDateChange($event)"
    [iconDisplay]="'input'"
    [showIcon]="true"
    inline="true"
  >
  </p-datepicker>
</div>

<div class="flex gap-4 mt-5 w-[322px] mx-auto">
  <div class="flex flex-col">
    <label for="calendar" class="text-sm font-medium text-text-900">
      Data
    </label>
    <p-datepicker
      id="calendar"
      class="mt-2"
      inputId="calendar"
      dateFormat="dd/mm/yy"
      [placeholder]="placeholder()"
      [disabled]="disabled"
      [(ngModel)]="date"
      [maxDate]="maxDate"
      [minDate]="minDate"
      (ngModelChange)="onDateChange($event)"
      [iconDisplay]="'input'"
      [showIcon]="true"
      [showOnFocus]="false"
      (onInput)="formatDateInput($event)"
    >
      <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
        <i class="-mt-1 material-symbols-outlined"> calendar_month </i>
      </ng-template>
    </p-datepicker>
  </div>

  <div class="flex flex-col">
    <label for="time" class="text-sm font-medium text-text-900">Hora</label>
    <p-datepicker
      class="mt-2"
      id="time"
      dateFormat="HH:mm"
      [(ngModel)]="time"
      [disabled]="disabled"
      [placeholder]="placeholder()"
      (ngModelChange)="onTimeChange($event)"
      [iconDisplay]="'input'"
      [showIcon]="true"
      [showOnFocus]="false"
      [timeOnly]="true"
      inputId="time"
      (onInput)="formatTimeInput($event)"
    >
      <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
        <i class="-mt-1 material-symbols-outlined"> schedule </i>
      </ng-template>
    </p-datepicker>
  </div>
</div>

<div class="flex justify-center w-full">
  <app-helper-text
    [showErrors]="showErrors"
    [errorMessage]="errorMessage"
    class="w-[322px] mx-auto mt-1"
  />
</div>
